var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-container"
  }, [_c('div', {
    staticClass: "left-toolbar"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.undoDisabled,
      "title": _vm.i18nt('designer.toolbar.undoHint')
    },
    on: {
      "click": _vm.undoHistory
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "undo"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.redoDisabled,
      "title": _vm.i18nt('designer.toolbar.redoHint')
    },
    on: {
      "click": _vm.redoHistory
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "redo"
    }
  })], 1), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": _vm.layoutType === 'PC' ? 'info' : ''
    },
    on: {
      "click": function($event) {
        return _vm.changeLayoutType('PC')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.toolbar.pcLayout')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.layoutType === 'Pad' ? 'info' : ''
    },
    on: {
      "click": function($event) {
        return _vm.changeLayoutType('Pad')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.toolbar.padLayout')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.layoutType === 'H5' ? 'info' : ''
    },
    on: {
      "click": function($event) {
        return _vm.changeLayoutType('H5')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.toolbar.mobileLayout')))])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "",
      "title": _vm.i18nt('designer.toolbar.nodeTreeHint')
    },
    on: {
      "click": _vm.showNodeTreeDrawer
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "node-tree"
    }
  })], 1)], 1), _vm._v(" "), _c('el-drawer', {
    staticClass: "node-tree-drawer",
    attrs: {
      "title": _vm.i18nt('designer.toolbar.nodeTreeTitle'),
      "direction": "ltr",
      "visible": _vm.showNodeTreeDrawerFlag,
      "modal": false,
      "size": 280,
      "append-to-body": "",
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showNodeTreeDrawerFlag = $event
      }
    }
  }, [_c('el-tree', {
    ref: "nodeTree",
    staticClass: "node-tree",
    attrs: {
      "data": _vm.nodeTreeData,
      "node-key": "id",
      "default-expand-all": "",
      "highlight-current": "",
      "icon-class": "el-icon-arrow-right"
    },
    on: {
      "node-click": _vm.onNodeTreeClick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right-toolbar"
  }, [_c('div', {
    staticClass: "right-toolbar-con"
  }, [(_vm.showToolButton('clearDesignerButton')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.clearFormWidget
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v(_vm._s(_vm.i18nt('designer.toolbar.clear')))]) : _vm._e(), _vm._v(" "), (_vm.showToolButton('previewFormButton')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.previewForm
    }
  }, [_c('i', {
    staticClass: "el-icon-view"
  }), _vm._v(_vm._s(_vm.i18nt('designer.toolbar.preview')))]) : _vm._e(), _vm._v(" "), (_vm.showToolButton('importJsonButton')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.importJson
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.toolbar.importJson')))]) : _vm._e(), _vm._v(" "), (_vm.showToolButton('exportJsonButton')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.exportJson
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.toolbar.exportJson')))]) : _vm._e(), _vm._v(" "), (_vm.showToolButton('exportCodeButton')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.exportCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.toolbar.exportCode')))]) : _vm._e(), _vm._v(" "), (_vm.showToolButton('generateSFCButton')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.generateSFC
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon-class": "vue-sfc"
    }
  }), _vm._v(_vm._s(_vm.i18nt('designer.toolbar.generateSFC')))], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.$slots), function(idx, slotName) {
    return [_vm._t(slotName)]
  })], 2)]), _vm._v(" "), (_vm.showPreviewDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.toolbar.preview'),
      "visible": _vm.showPreviewDialogFlag,
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "center": "",
      "destroy-on-close": true,
      "append-to-body": true,
      "width": "75%",
      "fullscreen": (_vm.layoutType === 'H5') || (_vm.layoutType === 'Pad')
    },
    on: {
      "update:visible": function($event) {
        _vm.showPreviewDialogFlag = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-render-wrapper",
    class: [_vm.layoutType === 'H5' ? 'h5-layout' : (_vm.layoutType === 'Pad' ? 'pad-layout' : '')]
  }, [_c('VFormRender', {
    ref: "preForm",
    attrs: {
      "form-json": _vm.formJson,
      "form-data": _vm.testFormData,
      "preview-state": true,
      "option-data": _vm.testOptionData,
      "global-dsv": _vm.designerDsv,
      "disabled-mode": false
    },
    on: {
      "appendButtonClick": _vm.testOnAppendButtonClick,
      "buttonClick": _vm.testOnButtonClick,
      "dataTableSelectionChange": _vm.testDTSC,
      "formChange": _vm.handleFormChange
    }
  })], 1)]), _vm._v(" "), _c('code-editor', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.testFunc),
      callback: function($$v) {
        _vm.testFunc = $$v
      },
      expression: "testFunc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getFormData
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.getFormData')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.resetForm')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setFormDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.disableForm')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setFormEnabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.enableForm')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.switchReadMode
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.switchReadMode')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showPreviewDialogFlag = false
      }
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.closePreview')))]), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.testSetFormData
    }
  }, [_vm._v("Test SFD")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.testDataTable
    }
  }, [_vm._v("Test DT")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.getDTData
    }
  }, [_vm._v("getDTData")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.testSetFormJson
    }
  }, [_vm._v("Test SFJ")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.testLoadFormJson
    }
  }, [_vm._v("Async Load")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.testSubFormHide
    }
  }, [_vm._v("Test SFH")]) : _vm._e(), _vm._v(" "), (false) ? _c('el-button', {
    on: {
      "click": _vm.logSubFormWidget
    }
  }, [_vm._v("Log SFW")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showImportJsonDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.toolbar.importJson'),
      "visible": _vm.showImportJsonDialogFlag,
      "show-close": true,
      "center": "",
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showImportJsonDialogFlag = $event
      }
    }
  }, [_c('el-alert', {
    staticClass: "alert-padding",
    attrs: {
      "type": "info",
      "title": _vm.i18nt('designer.hint.importJsonHint'),
      "show-icon": ""
    }
  }), _vm._v(" "), _c('code-editor', {
    attrs: {
      "mode": 'json',
      "readonly": false
    },
    model: {
      value: (_vm.importTemplate),
      callback: function($$v) {
        _vm.importTemplate = $$v
      },
      expression: "importTemplate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doJsonImport
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.import')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showImportJsonDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.cancel')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showExportJsonDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.toolbar.exportJson'),
      "visible": _vm.showExportJsonDialogFlag,
      "append-to-body": "",
      "show-close": true,
      "center": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showExportJsonDialogFlag = $event
      }
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'json',
      "readonly": true
    },
    model: {
      value: (_vm.jsonContent),
      callback: function($$v) {
        _vm.jsonContent = $$v
      },
      expression: "jsonContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "copy-json-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.jsonRawContent
    },
    on: {
      "click": _vm.copyFormJson
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyJson')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.saveFormJson
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.saveFormJson')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showExportJsonDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showExportCodeDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.toolbar.exportCode'),
      "visible": _vm.showExportCodeDialogFlag,
      "append-to-body": "",
      "show-close": true,
      "center": "",
      "width": "65%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showExportCodeDialogFlag = $event
      }
    }
  }, [_c('el-tabs', {
    staticClass: "no-box-shadow no-padding",
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeCodeTab),
      callback: function($$v) {
        _vm.activeCodeTab = $$v
      },
      expression: "activeCodeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Vue",
      "name": "vue"
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'html',
      "readonly": true,
      "user-worker": false
    },
    model: {
      value: (_vm.vueCode),
      callback: function($$v) {
        _vm.vueCode = $$v
      },
      expression: "vueCode"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "HTML",
      "name": "html"
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'html',
      "readonly": true,
      "user-worker": false
    },
    model: {
      value: (_vm.htmlCode),
      callback: function($$v) {
        _vm.htmlCode = $$v
      },
      expression: "htmlCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "copy-vue-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.vueCode
    },
    on: {
      "click": _vm.copyVueCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyVueCode')))]), _vm._v(" "), _c('el-button', {
    staticClass: "copy-html-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.htmlCode
    },
    on: {
      "click": _vm.copyHtmlCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyHtmlCode')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.saveVueCode
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.saveVueCode')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.saveHtmlCode
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.saveHtmlCode')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showExportCodeDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFormDataDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "dialog-title-light-bg",
    attrs: {
      "title": _vm.i18nt('designer.hint.exportFormData'),
      "visible": _vm.showFormDataDialogFlag,
      "show-close": true,
      "center": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showFormDataDialogFlag = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #DCDFE6"
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'json',
      "readonly": true
    },
    model: {
      value: (_vm.formDataJson),
      callback: function($$v) {
        _vm.formDataJson = $$v
      },
      expression: "formDataJson"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "copy-form-data-json-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.formDataRawJson
    },
    on: {
      "click": _vm.copyFormDataJson
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyFormData')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.saveFormData
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.saveFormData')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showFormDataDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showExportSFCDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.toolbar.generateSFC'),
      "visible": _vm.showExportSFCDialogFlag,
      "append-to-body": "",
      "show-close": true,
      "center": "",
      "width": "65%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showExportSFCDialogFlag = $event
      }
    }
  }, [_c('el-tabs', {
    staticClass: "no-box-shadow no-padding",
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeSFCTab),
      callback: function($$v) {
        _vm.activeSFCTab = $$v
      },
      expression: "activeSFCTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Vue2",
      "name": "vue2"
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'html',
      "readonly": true,
      "user-worker": false
    },
    model: {
      value: (_vm.sfcCode),
      callback: function($$v) {
        _vm.sfcCode = $$v
      },
      expression: "sfcCode"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Vue3",
      "name": "vue3"
    }
  }, [_c('code-editor', {
    attrs: {
      "mode": 'html',
      "readonly": true,
      "user-worker": false
    },
    model: {
      value: (_vm.sfcCodeV3),
      callback: function($$v) {
        _vm.sfcCodeV3 = $$v
      },
      expression: "sfcCodeV3"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "copy-vue2-sfc-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.sfcCode
    },
    on: {
      "click": _vm.copyV2SFC
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyVue2SFC')))]), _vm._v(" "), _c('el-button', {
    staticClass: "copy-vue3-sfc-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.sfcCodeV3
    },
    on: {
      "click": _vm.copyV3SFC
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyVue3SFC')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.saveV2SFC
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.saveVue2SFC')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.saveV3SFC
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.saveVue3SFC')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showExportSFCDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d49cac06","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/toolbar-panel/index.vue
// module id = null
// module chunks = 